import {useEffect, useState} from 'react'

import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { Trade } from '@App/redux/slices/trade/trades/types'
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'

import { Select } from '../../../../../SpotOrderTrade/components/Select'
import {getTimestampFromPeriod, ReportsFilter, useSeeMarket} from '../../../../model'
import { Card } from '../Card'

import s from './styles.module.scss'
import {
  asyncGetMarketsAnalytics,
  asyncGetTopTradesAnalytics,
  MarketGroup,
  MiniMarket
} from "@Redux/slices/reports/ReportsSlice";
import {useAppSelector} from "@App/hooks";
import {marketAnalytics} from "@Redux/slices/reports/selectors";
import {currentWallet} from "@Redux/slices/user/selectors";
import {useDispatch} from "react-redux";

enum Result {
  Profit = 'Most profitable',
  Loss = 'Least profitable',
}
const options = [
  { name: Result.Profit, value: Result.Profit },
  { name: Result.Loss, value: Result.Loss },
]

export const YourMarkets = ({ filters }: {filters: ReportsFilter}) => {
  const [tradeResult, setTradeResult] = useState(Result.Profit)
  const marketGroups = useAppSelector(marketAnalytics)
  const wallet = useAppSelector(currentWallet)
  const dispatch = useDispatch()
  const timestampFrom = getTimestampFromPeriod(filters.period)

  const args = {
    timestampInterval: {
      timestampFrom: timestampFrom,
      timestampTo:   null
    },
    profitable: tradeResult === Result.Profit
  }

  useEffect(() => {
    if (!wallet?.id) return
    dispatch(asyncGetMarketsAnalytics(args))
  }, [wallet?.id, filters.period, tradeResult])

  return (
    <Card
      className={s.container}
      title="Your Markets"
      contentClassName={s.content}
      headerRightElement={
        <Select
          value={tradeResult}
          options={options}
          containerClassName={s.selectContainer}
          inputClassName={s.select}
          optionClassName={s.option}
          onChange={(val) => setTradeResult(val as Result)}
        />
      }
    >
      <div className={s.header}>
        <div className={s.segment}>Market</div>

        <div className={cn(s.segment, s.end)}>Trades</div>
        <div className={cn(s.segment, s.end)}>Profit &amp; Loss</div>
      </div>

      <div className={s.trades}>
        {marketGroups.map((group) => (
          <TradeGroup key={group.market.id} group={group} />
        ))}
      </div>
    </Card>
  )
}
const TradeGroup = ({ group }: { group: MarketGroup }) => {
  const { seeMarket } = useSeeMarket({
    sourceCurrency: group.market.source_instrument_code,
    targetCurrency: group.market.target_instrument_code,
  })
  return (
    <div className={s.trade} key={group.market.id} onClick={() => seeMarket()}>
      <div className={cn(s.segment, s.left)}>
        <MarketIcon
          className={s.icon}
          symbol={group.market.symbol}
        />
        <div className={s.content}>
          <div className={s.name}>
            {group.market.title}
          </div>
        </div>
      </div>
      <div className={cn(s.segment, s.middle)}>
        <span className={s.badge}>{group.trades_count}</span>
      </div>
      <div className={cn(s.segment, s.right, group.total_result <= 0 && s.negative)}>
        {getValueWithCurrency(group.market.target_instrument_code, group.total_result)}
      </div>
    </div>
  )
}
